import { Image, Text, View } from "@react-pdf/renderer"
import staticPath from "../../config/staticPath"
import { colors } from "../../config/theme"

type Hint = {
  text: string | undefined
}

type HintProps = {
  hint: Hint | undefined
}

export const Hint = ({ hint }: HintProps) => {
  if (!hint?.text) return null
  const { text } = hint

  return (
    <View
      style={{
        padding: 16,
        backgroundColor: colors.grey,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 10,
          fontSize: 12,
        }}
      >
        <Image
          cache={false}
          style={{
            height: 12,
            width: 12,
          }}
          src={{
            uri: staticPath("/images/icon-bulb.png"),
            method: "GET",
            headers: {},
            body: "",
          }}
        />
      </View>

      <Text style={{ fontSize: 12, letterSpacing: 0.02 }}>{text}</Text>
    </View>
  )
}
